<template>
  <div class="row">
    <div class="col-md-12">
      <div class="shadow p-3 mb-3 bg-white rounded">
        <h5>Listing Options</h5>
        <div class="mb-2">
          <button class="btn btn-secondary rounded mr-2" @click="onClickChangeStatus('PUBLISH')">
            <i class="far fa-eye"></i>
            PUBLISH
          </button>
          <button class="btn btn-secondary rounded" @click="onClickChangeStatus('UNPUBLISH')">
            <i class="far fa-eye-slash"></i>
            UNPUBLISH
          </button>
        </div>
        <div class="button-add">
          <button
            class="btn btn-secondary btn-block rounded"
            @click="onAdd('experience')"
          >ADD EXPERIENCE</button>
          <button class="btn btn-secondary btn-block rounded" @click="onAdd('tour')">ADD TOUR</button>
          <button class="btn btn-secondary btn-block rounded" @click="onAdd('event')">ADD EVENT</button>
          <button class="btn btn-secondary btn-block rounded" @click="onAdd('story')">ADD STORY</button>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="shadow p-3 mb-3 bg-white rounded filter">
        <h5>Filter Listings</h5>
        <div class>
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="Search content"
              aria-label="Search content"
              aria-describedby="basic-addon2"
              v-model="search"
            />
            <div class="input-group-append">
              <span class="input-group-text" id="basic-addon2">
                <i class="fas fa-search"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 py-1">
            <button class="btn btn-status btn-block">Approved</button>
          </div>
          <div class="col-md-4 py-1">
            <button class="btn btn-status btn-block">Pending</button>
          </div>
          <div class="col-md-4 py-1">
            <button class="btn btn-status btn-block">Rejected</button>
          </div>
          <div class="col-md-4 py-1">
            <button class="btn btn-status btn-block">Published</button>
          </div>
          <div class="col-md-4 py-1">
            <button class="btn btn-status btn-block">Unpublished</button>
          </div>
          <div class="col-md-4 py-1">
            <button class="btn btn-status btn-block">Incomplete</button>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-4 py-1">
            <button
              class="btn btn-experiences btn-block"
              :class="{active: btn.experience}"
              @click="addTypes('experience')"
            >Experiences</button>
          </div>
          <div class="col-md-4 py-1">
            <button
              class="btn btn-tours btn-block"
              :class="{active: btn.tour}"
              @click="addTypes('tour')"
            >Tours</button>
          </div>
          <div class="col-md-4 py-1">
            <button
              class="btn btn-events btn-block"
              :class="{active: btn.event}"
              @click="addTypes('event')"
            >Events</button>
          </div>
          <div class="col-md-4 py-1">
            <button
              class="btn btn-stories btn-block"
              :class="{active: btn.story}"
              @click="addTypes('story')"
            >Stories</button>
          </div>
        </div>
        <div class>
          <select v-model="sort" class="form-control">
            <option value="TITLE">Sort by title</option>
            <option value="CREATED_AT">Sort by date posted</option>
          </select>
        </div>
        <div class>
          <div class="row">
            <div class="col-md-6">
              <button class="btn btn-apply btn-block" @click="onSearch">
                <span></span>
                <span>APPLY</span>
                <i class="fas fa-check"></i>
              </button>
            </div>
            <div class="col-md-6">
              <button class="btn btn-reset btn-block" @click="onReset">
                <span></span>
                <span>RESET FILTERS</span>
                <i class="fas fa-redo"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      types: [],
      sort: 'CREATED_AT',
      btn: {
        experience: false,
        tour: false,
        event: false,
        story: false,
      },
    };
  },
  methods: {
    onAdd(type) {
      this.$emit("onAdd", type);
    },
    onClickChangeStatus(status) {
      this.$emit("onClickChangeStatus", status);
    },
    onSearch() {
      const data = {
        search: this.search,
        types: this.types,
        sort: this.sort
      };
      this.$emit("search", data);
    },
    onReset() {
      this.search = "";
      this.types = [];
      this.btn.experience = false;
      this.btn.tour = false;
      this.btn.event = false;
      this.btn.story = false;
    },
    addTypes(type) {
      const index = this.types.indexOf(type);
      if (index > -1) {
        this.types.splice(index, 1);
      } else {
        this.types.push(type);
      }

      if (type == "experience") {
        this.btn.experience = !this.btn.experience;
      }

      if (type == "tour") {
        this.btn.tour = !this.btn.tour;
      }

      if (type == "event") {
        this.btn.event = !this.btn.event;
      }

      if (type == "story") {
        this.btn.story = !this.btn.story;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h5 {
  color: var(--primary-color);
}
.filter {
  .btn {
    color: #fff;
    border-radius: 19px;
    text-transform: none;

    &.btn-status {
      background-color: var(--primary-color);
    }
    &.btn-experiences {
      background-color: var(--experience-color);
    }
    &.btn-tours {
      background-color: var(--tour-color);
    }
    &.btn-events {
      background-color: var(--event-color);
    }
    &.btn-stories {
      background-color: var(--story-color);
    }

    &.btn-apply {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: var(--primary-color);
    }

    &.btn-reset {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #58595b;
    }

    &:hover {
      background-color: #58595b;
    }

    &.active {
      background-color: #58595b;
    }
  }
}
</style>